// ── shark-week.js — tap feedback (visible, not subtle) ────────
(function () {
  'use strict';
  if (!document.body.classList.contains('shark-week-active')) return;

  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function syncReducedMotionState() {
    var active = isReducedMotion();
    document.documentElement.classList.toggle('sw-reduced-motion', active);
    document.documentElement.dataset.swReducedMotion = active ? 'true' : 'false';
  }

  syncReducedMotionState();
  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', syncReducedMotionState);
  } else if (typeof reducedMotionQuery.addListener === 'function') {
    reducedMotionQuery.addListener(syncReducedMotionState);
  }

  // ── 1. Urgency pill text ("7 days of Shark Week!") ───────────
  // Shark Week window: start_date → end_date (inclusive calendar days).
  function daysRemaining(fromMs, toMs) {
    return Math.max(0, Math.ceil((toMs - fromMs) / 86400000));
  }

  function urgencyText(now, startMs, endMs) {
    if (now > endMs) return 'Shark Week ended';

    // Before opening day: show the full event length (e.g. 7 days).
    if (startMs && now < startMs) {
      var totalDays = daysRemaining(startMs, endMs);
      if (totalDays > 1) return totalDays + ' days of Shark Week!';
      if (totalDays === 1) return '1 day of Shark Week!';
      return 'Shark Week starts soon';
    }

    var remainingMs = endMs - now;
    var days = daysRemaining(now, endMs);
    var hours = Math.floor((remainingMs % 86400000) / 3600000);
    if (days > 1) return days + ' days of Shark Week!';
    if (days === 1) return '1 day of Shark Week!';
    if (hours > 1) return hours + ' hours of Shark Week!';
    if (hours === 1) return '1 hour of Shark Week!';
    return 'Shark Week ends soon';
  }

  var urgencyEls = document.querySelectorAll('[data-sw-urgency]');
  if (urgencyEls.length) {
    var endDate = new Date(urgencyEls[0].dataset.swUrgency);
    var startRaw = urgencyEls[0].dataset.swUrgencyStart;
    var startDate = startRaw ? new Date(startRaw) : null;
    var startMs = startDate && !isNaN(startDate.getTime()) ? startDate.getTime() : null;
    var endMs = endDate.getTime();

    function tickUrgency() {
      var text = urgencyText(Date.now(), startMs, endMs);
      urgencyEls.forEach(function (el) {
        var target = el.querySelector('[data-sw-urgency-text]');
        if (target) target.textContent = text;
      });
    }
    tickUrgency();
    setInterval(tickUrgency, 60000);
  }

  // ── 2. Product card press wobble (CSS :active + JS replay) ──
  function triggerWobble(el) {
    el.classList.remove('sw-tap-card--wobble');
    void el.offsetWidth;
    el.classList.add('sw-tap-card--wobble');
    window.setTimeout(function () {
      el.classList.remove('sw-tap-card--wobble');
    }, 500);
  }

  document.querySelectorAll('.sw-tap-card').forEach(function (card) {
    card.addEventListener('pointerdown', function () {
      triggerWobble(card);
    });
  });

  // ── 3. Hero boot tap — wobble + splash ring ─────────────────
  var heroVisual = document.querySelector('[data-sw-hero-boot]');
  if (heroVisual) {
    function playHeroTap() {
      heroVisual.classList.remove('sw-hero__visual--wobble', 'sw-hero__visual--splash');
      void heroVisual.offsetWidth;
      heroVisual.classList.add('sw-hero__visual--wobble');
      if (!isReducedMotion()) {
        heroVisual.classList.add('sw-hero__visual--splash');
        window.setTimeout(function () {
          heroVisual.classList.remove('sw-hero__visual--splash');
        }, 700);
      }
    }
    heroVisual.addEventListener('click', playHeroTap);
    heroVisual.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        playHeroTap();
      }
    });
  }

  // ── 4. Add to cart — squeeze the button ─────────────────────
  document.querySelectorAll('[data-sw-jaw-bite]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.add('sw-jaw-bite--active');
      if (navigator.vibrate && !isReducedMotion()) {
        navigator.vibrate(12);
      }
      window.setTimeout(function () {
        btn.classList.remove('sw-jaw-bite--active');
      }, 480);
    });
  });
})();
